'use strict';

export class MyProfileCtrl
{
	
	$scope;
	notify;
	jsDataService;
	pageProgress;
	$mdDialog;
	
	progress = false;
	submitted = false;
	
	recaptchaResponse;

	postData = {
		name: '',
		lastname: '',
		email: ''
	};
	
	constructor($scope, jsDataService, notify, pageProgress, $mdDialog){
		'ngInject';
		this.$scope = $scope;
		this.$mdDialog = $mdDialog;
		this.notify = notify;
		this.jsDataService = jsDataService;
		this.pageProgress = pageProgress;
		this.postData.name = this.jsDataService.get('userData').name;
		this.postData.lastname = this.jsDataService.get('userData').lastname;
		this.postData.email = this.jsDataService.get('userData').email;
	}
	
	submitProfile(e){
		const url = this.jsDataService.get('submitUrl');
		if(url){
			const self = this;
			const rec = self.jsDataService.get('recaptcha');
			if(rec){
				grecaptcha.ready(function() {
					grecaptcha.execute(rec.siteKey, {action: 'submit'}).then(function(token){
						self.recaptchaResponse = token;
						self.submitData(e);
					});
				});
			}
			else{
				self.submitData(e);
			}
			
		}
	}
	
	submitData(e){
		const url = this.jsDataService.get('submitUrl');
		if(url){
			const self = this;
			let dat = this.postData;
			const rec = this.jsDataService.get('recaptcha');
			if(rec){
				dat[rec.field] = this.recaptchaResponse;
			}
			this.$scope.basicHttpConfigProcess({
				url: url,
				method: 'POST',
				responseType: 'json',
				data: dat
			}).then(function(response){
				self.progress = false;
				if(response.data){
					if(response.data.success){
						self.submitted = false;
					}
					else{
						self.submitted = false;
					}
				}
			}, function(response){
				self.progress = false;
				self.submitted = false;
			});
		}
	}

	sendPassChangeMail(ev){
		const url = this.jsDataService.get('passChangeUrl');
		if(typeof(url) !== 'undefined' && url !== ''){
			const confirmTexts = this.jsDataService.get('passChangeConfirmTexts');
			const confirm = this.$mdDialog.confirm()
				.title(confirmTexts.title)
				.htmlContent(confirmTexts.content)
				.ariaLabel(confirmTexts.title)
				.targetEvent(ev)
				.ok(confirmTexts.ok)
				.cancel(confirmTexts.cancel);
			this.$mdDialog.show(confirm).then(() => {
				this.$scope.basicHttpConfigProcess({
					url: url,
					method: 'GET',
					responseType: 'json'
				}).then((results) => {
	
				});
			}, () => {});
		}
	}
}
	